import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import moment from "moment";
import { toast } from "react-toastify";

export default function CoinPackage() {
  
  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [searchTourName, setSearchTourName] = React.useState();
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  // const onPaginationChange = (start, end) => {
  //   setPagination({ start: start, end: end });
  // };

  const LoginSchema = Yup.object().shape({
    facebook: Yup.string().required("required"),
    telegram: Yup.string().required("required"),
    instagram: Yup.string().required("required"),
    whatsApp: Yup.string().required("required"),
    // privacyPolicy: Yup.string().required("required"),
    // termsCondition: Yup.string().required("required"),
    // helpUrl: Yup.string().required("required"),
    email: Yup.string().required("required"),
    contactNo: Yup.string().required("required"),
    // contactUs: Yup.string().required("required"),
  });

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/social/get-social`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        if (response.data.status) {
          console.log("response.data.message[0]", response.data);
          setRowValue(response.data.data);
        } else {
          toast.error(response.data.message || "Failed to fetch social links");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log("getBranch error :::", error);
        toast.error("Network error: Failed to fetch social links");
      });
  };

  const searchingData = [];
  let data = [];
  console.log("tableData 111 ---", tableData, searchTourName);
  if (searchTourName) {
    console.log("tableData 222 ---", tableData, tableData.length > 0);
    data = tableData.filter((item) => {
      return Object.values(item?.tourName)
        .join("")
        .includes(searchTourName.toLowerCase());
    });
    console.log("data 111 ---", data);
    data?.map((dataItem) => searchingData.push(dataItem));
  } else {
    tableData.map((dataItem) => searchingData.push(dataItem));
  }

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const updateTournament = (value) => {
    setButtonLoader(true);
    let merged = { ...value, id: rowValue?._id };
    console.log("merged::::>", merged);

    axios
      .patch(
        `${API_URL}/api/admin/social/update-social/${rowValue?._id}`,
        merged
      )
      .then((res) => {
        setButtonLoader(false);
        console.log("update :::", res.data);
        if (res.data.status) {
          socket.emit("socialUpdate");
          successEdit(res.data.message);
        } else {
          toast.error(res.data.message || "Failed to update social settings");
        }
      })
      .catch((err) => {
        setButtonLoader(false);
        console.log("update err :::", err);
        toast.error("Network error: Failed to update social settings");
      });
  };

  const successEdit = (msg) => {
    console.log("done");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={<h3>{msg}</h3>}
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
          // setIsPlayerEditButtonClicked(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  return (
    <>
      {alert}
      <div className="p-3">
        <div className="card p-3 border-0 shadow-sm">
          {!loader && (
            <Box sx={{ width: "100%" }}>
              {console.log("rowValue::: ", rowValue)}
              <Formik
                initialValues={{
                  facebook: rowValue?.facebook || "",
                  telegram: rowValue?.telegram || "",
                  instagram: rowValue?.instagram || "",
                  whatsApp: rowValue?.whatsApp || "",
                  email: rowValue?.email || "",
                  contactNo: rowValue?.contactNo || "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setButtonLoader(true);
                  console.log("update formik value :::", values, openValue);
                  updateTournament(values);
                }}
              >
                {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                  <div style={{ width: "100%" }}>
                    {accessObject?.getSocial == true ? (
                      <>
                        <Form>
                          <div className="row">
                            <div className="col-md-6 mb-4">
                              <label className="font-weight-bold text-muted small mb-2">
                                Facebook
                              </label>
                              <Field
                                type="text"
                                name="facebook"
                                disabled={!accessObject?.editSocial}
                                placeholder="Enter Facebook URL"
                                className={`form-control ${
                                  touched.facebook && errors.facebook ? "is-invalid" : ""
                                }`}
                                style={{
                                  borderRadius: "10px",
                                  padding: "12px 15px",
                                  border: "1px solid #e2e8f0",
                                  backgroundColor: "#f8fafc",
                                  height: "auto"
                                }}
                              />
                              <ErrorMessage component="div" name="facebook" className="invalid-feedback" />
                            </div>

                            <div className="col-md-6 mb-4">
                              <label className="font-weight-bold text-muted small mb-2">
                                Telegram
                              </label>
                              <Field
                                type="text"
                                disabled={!accessObject?.editSocial}
                                name="telegram"
                                placeholder="Enter Telegram URL"
                                className={`form-control ${
                                  touched.telegram && errors.telegram ? "is-invalid" : ""
                                }`}
                                style={{
                                  borderRadius: "10px",
                                  padding: "12px 15px",
                                  border: "1px solid #e2e8f0",
                                  backgroundColor: "#f8fafc",
                                  height: "auto"
                                }}
                              />
                              <ErrorMessage component="div" name="telegram" className="invalid-feedback" />
                            </div>

                            <div className="col-md-6 mb-4">
                              <label className="font-weight-bold text-muted small mb-2">
                                Instagram
                              </label>
                              <Field
                                type="text"
                                disabled={!accessObject?.editSocial}
                                name="instagram"
                                placeholder="Enter Instagram URL"
                                className={`form-control ${
                                  touched.instagram && errors.instagram ? "is-invalid" : ""
                                }`}
                                style={{
                                  borderRadius: "10px",
                                  padding: "12px 15px",
                                  border: "1px solid #e2e8f0",
                                  backgroundColor: "#f8fafc",
                                  height: "auto"
                                }}
                              />
                              <ErrorMessage component="div" name="instagram" className="invalid-feedback" />
                            </div>

                            <div className="col-md-6 mb-4">
                              <label className="font-weight-bold text-muted small mb-2">
                                WhatsApp
                              </label>
                              <Field
                                type="text"
                                name="whatsApp"
                                disabled={!accessObject?.editSocial}
                                placeholder="Enter WhatsApp URL"
                                className={`form-control ${
                                  touched.whatsApp && errors.whatsApp ? "is-invalid" : ""
                                }`}
                                style={{
                                  borderRadius: "10px",
                                  padding: "12px 15px",
                                  border: "1px solid #e2e8f0",
                                  backgroundColor: "#f8fafc",
                                  height: "auto"
                                }}
                              />
                              <ErrorMessage component="div" name="whatsApp" className="invalid-feedback" />
                            </div>

                            <div className="col-md-6 mb-4">
                              <label className="font-weight-bold text-muted small mb-2">
                                Email
                              </label>
                              <Field
                                type="text"
                                name="email"
                                disabled={!accessObject?.editSocial}
                                placeholder="Enter Email"
                                className={`form-control ${
                                  touched.email && errors.email ? "is-invalid" : ""
                                }`}
                                style={{
                                  borderRadius: "10px",
                                  padding: "12px 15px",
                                  border: "1px solid #e2e8f0",
                                  backgroundColor: "#f8fafc",
                                  height: "auto"
                                }}
                              />
                              <ErrorMessage component="div" name="email" className="invalid-feedback" />
                            </div>

                            <div className="col-md-6 mb-4">
                              <label className="font-weight-bold text-muted small mb-2">
                                Contact No
                              </label>
                              <Field
                                type="number"
                                name="contactNo"
                                disabled={!accessObject?.editSocial}
                                placeholder="Enter Contact No"
                                className={`form-control ${
                                  touched.contactNo && errors.contactNo ? "is-invalid" : ""
                                }`}
                                style={{
                                  borderRadius: "10px",
                                  padding: "12px 15px",
                                  border: "1px solid #e2e8f0",
                                  backgroundColor: "#f8fafc",
                                  height: "auto"
                                }}
                              />
                              <ErrorMessage component="div" name="contactNo" className="invalid-feedback" />
                            </div>
                          </div>

                          {accessObject?.editSocial == true && (
                            <div className="mt-2">
                              <button
                                type="submit"
                                className="btn btn-warning font-weight-bold px-4"
                                disabled={buttonLoader}
                                style={{
                                  borderRadius: "8px",
                                  border: "none",
                                  height: "45px",
                                  boxShadow: "0 4px 6px -1px rgba(255, 193, 7, 0.2)",
                                  color: "#000"
                                }}
                              >
                                <div className="d-flex align-items-center justify-content-center">
                                  <span>Submit</span>
                                  {buttonLoader && (
                                    <div className="spinner-border spinner-border-sm ml-2" role="status"></div>
                                  )}
                                </div>
                              </button>
                            </div>
                          )}
                        </Form>
                      </>
                    ) : (
                      <table
                        style={{
                          width: "100%",
                          backgroundColor: "rgba(0,0,0,.05)",
                        }}
                      >
                        <tr>
                          <td colSpan={7} className="p-3">
                            <h5 className="text-center mb-0">Access Denied</h5>
                          </td>
                        </tr>
                      </table>
                    )}
                  </div>
                )}
              </Formik>
            </Box>
          )}
          {accessObject?.getSocialList == true && loader && (
            <div className="mt-4">{loader && <Loader />}</div>
          )}
        </div>
      </div>
    </>
  );
}
